import React from 'react';

import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';

import { DisplayCostAppearance, textAppearances } from './displayCost.settings';

export const useDisplayCostHelper = (cost: number | string, appearance: DisplayCostAppearance) => {
	const t = useTranslation();

	const eur = t('general.eur');
	const month = t('general.month');

	const costText = React.useMemo(
		() => `${cost} <currency>${eur.toUpperCase()}</currency><frequency>/${month}</frequency>`,
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[cost]
	);

	return { costText, ...textAppearances[appearance] };
};
